import React, { useState } from 'react'

import { TbRewindForward30 } from "react-icons/tb";
import { BiShapeSquare } from "react-icons/bi";
import { MdCurrencyRupee } from "react-icons/md";
import { GoPasskeyFill } from "react-icons/go";
import { VscPercentage } from "react-icons/vsc";
import { GiReturnArrow } from "react-icons/gi";

import heroImg from '../../../../assets/bhutani/Wellness/wellnessHero.png'
import inner1 from '../../../../assets/bhutani/Wellness/wellness-1.jpg'
import inner2 from '../../../../assets/bhutani/Wellness/wellness-2.jpg'
import inner3 from '../../../../assets/bhutani/Wellness/wellness-3.jpg'
import inner4 from '../../../../assets/bhutani/Wellness/wellness-4.jpg'
import inner5 from '../../../../assets/bhutani/Wellness/wellness-5.webp'

import { ImageModal } from '../../../common/ImageModal';
import { ConnectForm } from '../../../common/ConnectForm';

const Wellness = () => {
    const [openImgModal, setOpenImgModal] = useState(false)
    const innerImgs = [inner1, inner2, inner3, inner4, inner5]

    const points = [
        {
            icon: BiShapeSquare,
            title: 'Size :- 200 sf',
        },
        {
            icon: GoPasskeyFill,
            title: 'Lease Guarantee of Rs.175 / sqft',
        },
        {
            icon: VscPercentage,
            title: '12% AR to 24% AR',
        },
        {
            icon: MdCurrencyRupee,
            title: 'Payment Plan- 30:70',
        },
        {
            icon: TbRewindForward30,
            title: ' 30% on Booking',
        },
        {
            icon: GiReturnArrow,
            title: '70% on Possession',
        }
    ]


    return (
        <div className="w-full min-h-screen bg-gray-100">
            <div
                className="w-full h-[500px] bg-cover bg-center mb-5"
                style={{ backgroundImage: `url('${heroImg}')` }}
            ></div>

            <div class="flex flex-col md:flex-row px-2.5 gap-4">
                <div class="w-full md:w-2/3 flex flex-col gap-4">
                    <div class="">
                        <div className="max-w-5xl mx-auto p-6">
                            <p className="text-md text-gray-700 mb-4 text-justify"> The luxury wellness center at Bhutani City Center 32 in Noida Sector 32 is a sanctuary of health and rejuvenation.
                                Nestled in the vibrant heart of Noida, this wellness zone is designed to provide a serene escape, catering to your
                                mind, body, and soul1.</p>

                            <p className="text-md text-gray-700 mb-4 text-justify">Indulge in a range of premium wellness services, from personalized fitness programs and spa therapies to meditation
                                zones and nutrition consultations. The center is equipped with advanced spa therapies, fitness regimes, and holistic
                                healing services, all under one roof1. Whether you’re looking for stress relief, physical fitness, or a holistic approach
                                to well-being, Bhutani Wellness has you covered.</p>
                            <p className="text-md text-gray-700 mb-4 text-justify"> Situated at the crossroads of convenience and luxury, the wellness center offers an atmosphere of tranquility and
                                health, making it the perfect place to achieve a balanced lifestyle.</p>
                        </div>
                        <div className="max-w-4xl mx-auto p-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {points.map((point, index) => (
                                    <div
                                        key={index}
                                        className="flex items-center bg-white p-4 rounded-lg shadow hover:shadow-lg transition-shadow duration-300"
                                    >
                                        {React.createElement(point.icon, {
                                            size: 24,
                                            color: "green",
                                            className: "w-6 h-6 mr-3",
                                        })}
                                        <span className="text-gray-700 font-medium">{point.title}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <ConnectForm />
            </div>

            {openImgModal && (
                <ImageModal images={innerImgs} openImg={openImgModal} />
            )}
            <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 p-4">
                {innerImgs.map((data, index) => (
                    <div
                        key={index}
                        onClick={() => setOpenImgModal(true)}
                        className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
                    >
                        <img src={data} alt="Bhutani" className="w-full h-full object-cover" />
                    </div>
                ))}
            </div>

        </div>
    )
}
export default Wellness;